import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const ChartIcon = ({ width = "24", height = "24" }: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.251 8.99975H4.75C4.47375 8.99975 4.25 9.2235 4.25 9.49975V19.5C4.25 19.7763 4.47375 20 4.75 20H8.251C8.52725 20 8.751 19.7763 8.751 19.5V9.49975C8.751 9.2235 8.52725 8.99975 8.251 8.99975ZM7.751 19H5.25V9.99975H7.751V19ZM19.25 4H15.7542C15.478 4 15.2542 4.22375 15.2542 4.5V19.5C15.2542 19.7763 15.478 20 15.7542 20H19.25C19.5263 20 19.75 19.7763 19.75 19.5V4.5C19.75 4.22375 19.5263 4 19.25 4ZM18.75 19H16.2542V5H18.75V19Z"
          fill="#778AA7"
        />
        <path
          d="M13.7434 11.9727H10.2422C9.96594 11.9727 9.74219 12.1964 9.74219 12.4727V19.4999C9.74219 19.7762 9.96594 19.9999 10.2422 19.9999H13.7434C14.0197 19.9999 14.2434 19.7762 14.2434 19.4999V12.4727C14.2434 12.1962 14.0199 11.9727 13.7434 11.9727ZM13.2434 18.9999H10.7422V12.9727H13.2434V18.9999Z"
          fill="#1C3C6C"
        />
      </svg>
    </IconWrapper>
  );
};
